// =============================================================================
// Origin UI — src/components/ModuleRoute.tsx
// Route wrapper that checks module feature flags.
// Redirects to /home if the specified module is disabled.
// =============================================================================

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useModuleFlags } from '@/hooks/useModuleFlags';

interface ModuleRouteProps {
  module: string;
  children: ReactNode;
}

export function ModuleRoute({ module, children }: ModuleRouteProps) {
  const { isModuleEnabled, loaded } = useModuleFlags();

  if (!loaded) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        fontFamily: "'DM Sans', sans-serif",
        color: '#6B7885',
      }}>
        Loading...
      </div>
    );
  }

  if (!isModuleEnabled(module)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
